// eslint-disable-next-line no-unused-vars
document.addEventListener('DOMContentLoaded', () => {
	if (
		document.querySelector('.wp-block-ardent-health-care-search.provider') ||
		document.querySelector('.wp-block-ardent-health-care-search.location')
	) {
		const hash = window.location.hash
		const tabAnchors = document.querySelectorAll('.wp-block-ardent-health-care-search .tabs li a')
		const floatingHeight =
			document.querySelector('.wp-block-ardent-health-care-search .floating-card-container > div').offsetHeight +
			100

		document.querySelector('.wp-block-ardent-health-care-search').style.minHeight = floatingHeight + 'px'

		tabAnchors.forEach(anchor => {
			anchor.addEventListener('click', function (e) {
				const tabElement = e?.target ?? this
				const selectedTabId = tabElement?.hash?.replace('#', '')

				document.querySelectorAll('.wp-block-ardent-health-care-search .tab-content').forEach(el => {
					el.classList.remove('show')
					el.classList.add('hide')
				})
				// eslint-disable-next-line no-unused-vars
				document.querySelectorAll('.wp-block-ardent-health-care-search .tab-content').forEach(div => {
					if (div.getAttribute('id') === selectedTabId) {
						div.classList.remove('hide')
						div.classList.add('show')
					}
				})
			})
		})

		// Force all tab contents to hidden
		document.querySelectorAll('.wp-block-ardent-health-care-search .tab-content').forEach(el => {
			el.classList.remove('show')
			el.classList.add('hide')
		})

		// eslint-disable-next-line no-unused-vars
		document.querySelectorAll('.wp-block-ardent-health-care-search .tabs li').forEach(li => {
			const target = li.getAttribute('name').replace('-li', '')
			const selected =
				hash && hash.replace('#', '') === target ? true : li.classList.contains('selected') ? true : false
			// Check tab contents for selected tab and show it
			document.querySelectorAll('.wp-block-ardent-health-care-search .tab-content').forEach(div => {
				if (selected && div.getAttribute('id') === target) {
					document.querySelectorAll('.wp-block-ardent-health-care-search .tab-content').forEach(div => {
						div.classList.add('hide')
					})
					div.classList.remove('hide')
					div.classList.add('show')
				}
			})
		})
	}
})
